module.exports = __webpack_public_path__ + "img/tunisia.91251c44.svg";